<template>
    <div>
        <p>This is a <code>.deb</code> package built for Ubuntu/Mint Linux with no bundled Java Runtime.
            You need to install deb package using your system package management tools, such as synaptic,
            Ubuntu software, apt, dpkg, etc. </p>

        <div class="p-3">
            <strong>GanttProject {{ version }}</strong>
            <div class="help-text pb-3">Released on {{ releaseDate }}</div>
            <a role="button" class="btn btn-attention btn-lg" :href="`/dl/${version}/lin`">Download</a>
        </div>

        <p>GanttProject {{version}} requires Java Runtime version 7 or higher.
            Currently there is a number of Java Runtime vendors and versions.
            GanttProject works with any OpenJDK compatible Java Runtime, however, due to packaging
            and other reasons, it may not work out of the box with some combinations of operating system,
            Java Runtime vendor and version.</p>


        <p>This package was smoke-tested on the following configurations:</p>

        <ul>
            <li>Ubuntu 18.04 with Java Runtime packages: <code>openjdk-8-jre</code>, <code>oenjdk-11-jre</code>,
                <code>java-11-amazon-corretto-jdk</code>, <code>bellsoft-java11-runtime</code>.
            </li>
        </ul>

        <p>If you're using Linux distribution where deb packages are not supported, try using
            <a :href="`/dl/${version}/any`">platform-independent ZIP archive</a>
            which includes a launcher script <code>ganttproject</code> written in bash</p>
    </div>
</template>

<script>
    export default {
        name: "DownloadLin28",
        props: {
            releaseDate: String,
            version: String,
        }
    }
</script>

<style scoped>

</style>
